import { TransmissionTowerOffIcon } from './TransmissionTowerOffIcon';

/**
 * author: Simran
 * id C54CC9F5-7BCA-4368-B379-E0CCD221A567
 * name transmission-tower-off
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transmission-tower-off.svg
 * tags
 * - Home Automation 
 */
export const PowerlineOffIcon = TransmissionTowerOffIcon;
export default PowerlineOffIcon